import { render } from "./DetailsComponent.vue?vue&type=template&id=00cd8231"
import script from "./DetailsComponent.vue?vue&type=script&lang=js"
export * from "./DetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__